<template>
  <div class="hello">
    <h1>Welcome to {{ htmlname }}</h1>
    <h2>...Welcome...</h2>
    <div class="icp-buttom">
      {{htmlname}} | {{copyright}} | <a href="http://beian.miit.gov.cn">{{websiterecord}}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      htmlname: '个人开发测试',
      copyright: 'Copyright ©2016-' + new Date().getFullYear(),
      websiterecord: '闽ICP备16006474号-2'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  padding: 0;
  border: 0;
  margin: 0;
}
h1, h2 {
  font-weight: normal;
}
.icp-buttom a {
  color: #c2c2c2;
  text-decoration:none;
}
.icp-buttom{
  width: 100%;
  background: #3c3c3c;
  position: absolute;
  bottom: 0;
  color: #c2c2c2;
  font-size: 12px;
  font-family: microsoft yahei;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue